import _ from 'lodash';
import Service from './abstract';
import productsService from './products';
import currenciesService from './currencies';

const defaultWith = 'attributes,attributes.attribute,wallet,product,product.type,currency,currency.attributes,currency.attributes.attribute';
const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: defaultWith
};

class Accounts extends Service {
    constructor () {
        super('accounts');
    }

    get defaultOptionsFind () {
        return _.merge({}, super.defaultOptionsFind, defaultOptionsFind);
    }

    normalize (account) {
        if (_.isNil(account)) {
            return account;
        }

        // Prepare default properties
        account = super.normalize(account);

        // Prepare product
        if (account.product) {
            account.product = productsService.normalize(account.product);
        }

        // Prepare currency
        if (account.currency) {
            account.currency = currenciesService.normalize(account.currency);
        }
        return account;
    }
}

export default new Accounts();
